<rs-popup>
  <div class="rs-go-to-docusign-popup">
    <div class="rs-go-to-docusign-popup__title">{{(view ? 'popups.go-to-docusign.title2' : 'popups.go-to-docusign.title') | translate}}</div>
    <div class="rs-go-to-docusign-popup__actions">
      <button tabindex="-1" mat-raised-button color="primary" class="app__button" [mat-dialog-close]="true">{{'popups.go-to-docusign.sign-the-document' | translate}}</button>
      <button tabindex="-1" mat-raised-button color="primary" class="app__button" mat-dialog-close>{{'popups.go-to-docusign.back-to-rockspoon' | translate}}</button>
    </div>
  </div>
</rs-popup>
